export const MASSIVE_RESPONSE_WARNING_TOAST_OPTIONS = { autoClose: false } as const;

const SELECTION_LIMIT_WARNING_HEADER = 'x-selection-limit-warning';

const decodeSelectionLimitWarning = (value: string): string => {
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};

export const extractSelectionLimitWarning = (headers: Record<string, unknown>): string | null => {
    const rawValue = headers[SELECTION_LIMIT_WARNING_HEADER];
    if (typeof rawValue === 'string') {
        return rawValue ? decodeSelectionLimitWarning(rawValue) : null;
    }

    if (Array.isArray(rawValue) && typeof rawValue[0] === 'string') {
        return rawValue[0] ? decodeSelectionLimitWarning(rawValue[0]) : null;
    }

    return null;
};
